import { SET_LANGUAGE } from './actionTypes'

export const setLanguage = (language: string, stateLocation: string) => {
    return {
        type: SET_LANGUAGE,
        payload: {
            language,
            stateLocation
        }
    }
};



// WEBPACK FOOTER //
// ./modules/custom-language-watcher/actions/actions.ts